import { AlertColor } from "@mui/material";
import classNames from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { ampli } from "../../../../ampli";
import { IUserProperties } from "../../../../ampli/models";
import { ampliIncrementEvent } from "../../../../ampli/userIdentify";
import { ESCALATION_REASONS_AMPLI } from "../../../../pages/contract/constants";
import { ESenderRole } from "../../../../setup/api/services/contract/models";
import { doAction } from "../../../../setup/api/services/contractActions";
import { EContractActions } from "../../../../setup/api/services/contractActions/enum";
import {
  IContractActionRequestBody,
  IEscalationDTO,
} from "../../../../setup/api/services/contractActions/models";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { ETicketType } from "../../../../zendeskIntegration/enums";
import { ICreateTicketResponse } from "../../../../zendeskIntegration/models";
import { createTicket } from "../../../../zendeskIntegration/service";
import { DialogModal } from "../../../common/dialog";
import OutlinedButton from "../../../common/OutlinedButton";
import PrimaryButton from "../../../common/PrimaryButton";
import CustomizedSnackbars from "../../../customizedSnackbars";
import {
  returnCreateTicketRequestBody,
  returnEscalationDTO,
} from "../buyer/helper";
import { IEscalationData } from "../buyer/models";
import { EscalationForm } from "../forms/escalationForm";
import { IContractActionComponentProps } from "../models";
import { ConfirmPinCodeForm } from "../pinActionModal/confirmPinCodeForm";
// waitingForDelivery
import styles from "./waitingForDelivery.module.scss";

export const WaitingForDeliveryActions = (
  props: IContractActionComponentProps
) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [verifiedPinCode, setVerifiedPinCode] = useState<boolean>(false);
  const [isApproveDelivery, setIsApproveDelivery] = useState<boolean>(false);
  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>();
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");
  const { id } = useParams();
  const userId = AuthConfig.getUserInfo().id;
  const { t } = useTranslation();
  const { contract, actorType, refreshContractDetails } = props;
  const currentUser = AuthConfig.getMyInfo();
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const closeModal = () => {
    setModalOpen(false);
    setIsApproveDelivery(false);
    setVerifiedPinCode(false);
    setSnackBarOpen(false);
    setSnackBarColor(undefined);
    setSnackBarTitle("");
  };
  const actionSubmit = (
    contractAction: EContractActions,
    escalationDTO?: IEscalationDTO,
    escalationData?: IEscalationData
  ) => {
    if (id && userId) {
      const body: IContractActionRequestBody = {
        contractId: id,
        userId: userId,
        actorRole: actorType,
        receiverId: contract?.receiverId,
        senderId: contract.senderId,
        contractAction: contractAction,
        escalationDTO: escalationDTO,
      };
      doContractAction(body, escalationData);
    }
    closeModal();
  };
  const sendAmpliEventConfirmedDelivery = () => {
    ampli.confirmedDelivery({
      userRole: "buyer", // enum
      deliveryConfirmationDate: new Date().toISOString(), // string
      contractId: contract.shortId,
    });
  };
  const sendAmpliUserPropertiesForConfirmedDelivery = () => {
    ampliIncrementEvent(
      userId,
      IUserProperties.TOTAL_NUMBER_OF_DELIVERY_CONFIRMED
    );
  };
  const sendAmpliUserPropertiesForEscalation = () => {
    ampliIncrementEvent(userId, IUserProperties.TOTAL_NUMBER_OF_ESCALATION);
  };

  const sendAmpliEventEscalated = (escalationData?: IEscalationData) => {
    if (escalationData) {
      const escalationReasonsAmpli = escalationData.reasons.map((item) => {
        return ESCALATION_REASONS_AMPLI[item];
      });
      ampli.escalated({
        userRole: isSeller() ? "seller" : "buyer",
        escaltionType: "delivery",
        escalationReasons: escalationReasonsAmpli,
        additionalEscalationReasons: escalationData?.additionalReasons,
        contractId: contract.shortId,
      });
    }
  };

  const doContractAction = async (
    body: IContractActionRequestBody,
    escalationData?: IEscalationData
  ) => {
    const res = await doAction(body);
    if (res && res.sent === true) {
      if (body.contractAction === EContractActions.CUSTOMER_CONFIRM_DELIVERY) {
        sendAmpliEventConfirmedDelivery();
        sendAmpliUserPropertiesForConfirmedDelivery();
      }
      if (
        body.contractAction === EContractActions.CUSTOMER_DENY_DELIVERY ||
        body.contractAction === EContractActions.PROVIDER_ESCALATE_DELIVERY
      ) {
        sendAmpliEventEscalated(escalationData);
        sendAmpliUserPropertiesForEscalation();
      }
      setSnackBarStates(t("lbl_action_under_processing"), "success");
    } else {
      setSnackBarStates(t("lbl_cannot_make_this_call"), "error");
    }
    refreshContractDetails();
  };

  const onConfirm = () => {
    if (isApproveDelivery === true)
      return actionSubmit(EContractActions.CUSTOMER_CONFIRM_DELIVERY);
    else setVerifiedPinCode(true);
    return;
  };
  const onApproveDeliveryClick = () => {
    setIsApproveDelivery(true);
    toggleModal();
  };
  const onEscalateDeliveryClick = () => {
    setIsApproveDelivery(false);
    toggleModal();
  };
  const setSnackBarStates = (title: string, color: AlertColor) => {
    setSnackBarOpen(true);
    setSnackBarColor(color);
    setSnackBarTitle(title);
  };
  const isSeller = () => {
    return actorType === ESenderRole.PROVIDER;
  };
  const onEscalateClick = (reasons: string[], additionalReasons?: string) => {
    reasons = isSeller() ? [""] : reasons;
    const response = {
      request: {
        id: Number(String(new Date())),
        fields: [
          {
            id: Number(String(new Date())),
            value: "test",
          },
        ],
      },
    };
    const escalationDto = returnEscalationDTO(response, userId);
    const action = isSeller()
      ? EContractActions.PROVIDER_ESCALATE_DELIVERY
      : EContractActions.CUSTOMER_DENY_DELIVERY;
    actionSubmit(action, escalationDto, {
      reasons,
      additionalReasons,
    });
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
  };
  const returnAuthenticationTitle = () => {
    return t("lbl_authentication_through_pincode_title");
  };
  const returnAuthenticationSubTitle = () => {
    return isApproveDelivery
      ? t("lbl_approve_delivery_sub_title")
      : t("lbl_escalate_delivery_sub_title");
  };
  const returnEscalationTitle = () => {
    return isSeller()
      ? t("lbl_what_is_escalation_problems")
      : t("lbl_fill_escalation_problems_title");
  };
  const renderModal = () => {
    return (
      <DialogModal
        title={
          verifiedPinCode
            ? returnEscalationTitle()
            : returnAuthenticationTitle()
        }
        open={modalOpen}
        handleClose={async () => {
          closeModal();
        }}>
        {verifiedPinCode ? (
          <EscalationForm
            onEscalate={onEscalateClick}
            reasonsRequired={isSeller() ? false : true}
          />
        ) : (
          <ConfirmPinCodeForm
            description={returnAuthenticationSubTitle()}
            onConfirm={onConfirm}
          />
        )}
      </DialogModal>
    );
  };
  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };
  return (
    <div className={styles.container}>
      {renderModal()}
      {renderSnackBar()}
      {!isSeller() && (
        <PrimaryButton
          id={`contract_details_approve_button`}
          onClick={onApproveDeliveryClick}>
          {t("lbl_approve_delivery")}
        </PrimaryButton>
      )}
      <div className={styles["escalation_button"]}>
        <OutlinedButton
          id={`contract_details_have_a_problem_button`}
          onClick={onEscalateDeliveryClick}>
          <p className={classNames("subtitle2", "primary")}>
            {" "}
            {t("lbl_btn_have_problem")}
          </p>
        </OutlinedButton>
      </div>
    </div>
  );
};
